import { Box, Button, Dialog, IconButton } from "@material-ui/core";
import { useState } from "react";
import ClearIcon from "@material-ui/icons/Clear";
import { useSelector } from "react-redux";

import { useSummaryStyles } from "./summary.styles";
import { RootState } from "../../../../app/rootReducer";
import {
  QuoteAssumptions,
  LeadAssumptions,
  LeadAssumptionsHomeFarm,
  LeadAssumptionsBusiness
} from "../../../../app/consts";
import { useBreakpoint } from "../../../../hooks/useBreakpoint";
import { EQuotePurchaserType } from "../../../../api/Types";
import { quoteVat } from "../../../../app/utils";
import { solarGrantAmountAvailable } from "../../../../app/utils";
import { PriceFormat } from "../../../../components/typography/PriceFormat";

export const Potential = () => {
  const classes = useSummaryStyles();
  const [openAssumptions, setOpenAssumptions] = useState(false);
  const { solarReport, quote, lead } = useSelector((state: RootState) => state.quote);
  const { isMoreThanSm } = useBreakpoint();

  const isSolar = quote?.type?.includes("Solar");

  var initialOutlay = Number(quote?.price ?? 0) - Number(isSolar ? solarGrantAmountAvailable(quote, solarReport) : 0);

  if (quote?.purchaserType !== EQuotePurchaserType.Home && isSolar) {
    initialOutlay -= quoteVat(quote!);
  }

  if (!quote?.isGraphVisible || solarReport === null) return null;

  var assumptions = QuoteAssumptions;

  if (lead) {
    assumptions = LeadAssumptions;
    if (solarReport.purchaserType === EQuotePurchaserType.Business) {
      assumptions = assumptions.concat(LeadAssumptionsBusiness);
    } else {
      assumptions = assumptions.concat(LeadAssumptionsHomeFarm);
    }
  }

  return (
    <Box className={`${classes.potential} ${quote?.isGraphVisible ? "" : "graphHidden"}`}>
      <Box position={"absolute"} height={"100%"} top={0} left={0}>
        <img src="images/checkout/money_man.png" alt="potential" height={"100%"} width={"auto"} />
      </Box>
      <Box zIndex={1}>
        {quote?.isGraphVisible && (
          <Box className={classes.potentialSaving}>
            <p>Potential Savings</p>
            <Button
              onClick={() => {
                setOpenAssumptions(true);
              }}
              className={classes.potentialSavingButton}
            >
              View Assumptions
            </Button>
          </Box>
        )}
        <Box className={classes.potentialLifeTime}>
          <p>Total lifetime savings</p>
          <span>
            <PriceFormat
              value={
                (solarReport?.savingsEstimateByYear?.[solarReport?.savingsEstimateByYear?.length - 1] ?? 0) +
                initialOutlay
              }
            />
          </span>
        </Box>
        <Box className={classes.potentialOutlay}>
          <p>Initial outlay</p>
          <span>
            -
            <PriceFormat value={initialOutlay} />
          </span>
        </Box>
        <Box className={classes.potentialNet}>
          <p>Net savings</p>
          <span>
            <PriceFormat
              value={solarReport?.savingsEstimateByYear?.[solarReport?.savingsEstimateByYear?.length - 1] ?? 0}
            />
          </span>
        </Box>
      </Box>
      <Dialog
        open={openAssumptions}
        onClose={() => {
          setOpenAssumptions(false);
        }}
        aria-labelledby="Summary-dialog-title"
        maxWidth="md"
        fullWidth
      >
        <Box padding={"42px"}>
          <Box position={"absolute"} top="10px" right="20px">
            <IconButton
              onClick={() => {
                setOpenAssumptions(false);
              }}
            >
              <ClearIcon />
            </IconButton>
          </Box>
          <Box>
            <Box
              fontSize={isMoreThanSm ? "16px" : "14px"}
              textAlign={isMoreThanSm ? "left" : "center"}
              fontWeight={400}
              mb="10px"
              color={isMoreThanSm ? "#4b5462" : "rgba(17, 21, 33, 0.65)"}
            >
              To achieve these results your location, the slope of your roof, and the system's orientation are all
              considered.
            </Box>
            <Box
              fontSize={isMoreThanSm ? "16px" : "14px"}
              textAlign={isMoreThanSm ? "left" : "center"}
              mb={"35px"}
              fontWeight={400}
              color={isMoreThanSm ? "#4b5462" : "rgba(17, 21, 33, 0.65)"}
            >
              The following assumptions were made when calculating your solar proposals figures:
            </Box>
          </Box>
          <Box width={"100%"} fontSize={"14px"} fontWeight={400} color={"rgba(17, 21, 33, 0.65)"}>
            {assumptions.map((item, idx) => (
              <Box mb="10px" key={idx}>
                {item}
              </Box>
            ))}
          </Box>
        </Box>
      </Dialog>
    </Box>
  );
};
